export default "__VITE_ASSET__BSD6eQ0T__"